import { render } from "./SnsConnectionSettingPage.vue?vue&type=template&id=5ef252a3"
import script from "./SnsConnectionSettingPage.vue?vue&type=script&lang=js"
export * from "./SnsConnectionSettingPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__